export const SITE_URL = "https://piconsultants.us";

export const SECTION_PATHS = {
  Home: "/",
  Apps: "/products",
  "About Us": "/about",
  Support: "/support",
  "Try the Beta": "/beta",
  Contact: "/contact",
  "LF Export": "/tools/lf-export",
};

export const PRODUCT_PATHS = {
  PEARL: "/products/pearl",
  PARIS: "/products/paris",
  PixbyPix: "/products/pixbypix",
  Praana: "/products/praana",
  PRISM: "/products/prism",
  "Vedic Phala": "/products/vedic-phala",
};

const defaultDescription =
  "Pi Consultants builds AI-enabled web and mobile products, enterprise platforms, accessibility tools, and environmental compliance software.";

export const SEO_BY_PATH = {
  "/": {
    title: "Pi Consultants | AI Product Development & Enterprise Software",
    description:
      "Pi Consultants designs and builds AI-enabled web, mobile, compliance, accessibility, and enterprise software products from California.",
  },
  "/products": {
    title: "Software Products & AI Applications | Pi Consultants",
    description:
      "Explore software products built by Pi Consultants for Vedic astrology, environmental compliance, accessibility, media forensics, monitoring, and project management.",
  },
  "/about": {
    title: "About Pi Consultants | AI & Enterprise Software Team",
    description:
      "Meet the Pi Consultants team and its experience delivering AI products, enterprise platforms, public-sector systems, and digital transformation programs.",
  },
  "/support": {
    title: "Product Support & Custom Software Services | Pi Consultants",
    description:
      "Get support, upgrades, integrations, maintenance, and custom software services for products and enterprise applications built by Pi Consultants.",
  },
  "/beta": {
    title: "Software Beta Programs | Pi Consultants",
    description:
      "Preview and test upcoming Pi Consultants web and mobile software products, review available applications, and learn how to request beta access.",
  },
  "/contact": {
    title: "Contact Pi Consultants | AI Product Development",
    description:
      "Contact Pi Consultants about AI product development, enterprise software, integrations, accessibility, and product support.",
  },
  "/products/pearl": {
    title: "PEARL Environmental Incentive Software | Pi Consultants",
    description:
      "PEARL is an AI-enabled environmental incentive and emission-reduction analysis product built by Pi Consultants.",
  },
  "/products/paris": {
    title: "PARIS Accessibility Compliance Software | Pi Consultants",
    description:
      "PARIS combines website and PDF accessibility auditing, remediation workflows, WCAG analysis, and compliance reporting.",
  },
  "/products/pixbypix": {
    title: "PixbyPix Media Forensics Software | Pi Consultants",
    description:
      "PixbyPix is a Pi Consultants product for video, image, metadata, and pixel-level media integrity analysis.",
  },
  "/products/praana": {
    title: "Praana Environmental Monitoring Platform | Pi Consultants",
    description:
      "Praana is an environmental monitoring and public-notification platform for air, water, climate, and noise data.",
  },
  "/products/prism": {
    title: "PRISM AI Project Management Platform | Pi Consultants",
    description:
      "PRISM combines Waterfall, Agile, and hybrid project planning with scheduling, resource analysis, collaboration, and AI-assisted workflows.",
  },
  "/tools/lf-export": {
    title: "LF Export Utility for Laserfiche | Pi Consultants",
    description:
      "Download the LF Export Utility: exports Laserfiche documents and metadata to a folder with short names, resumable runs, a live dashboard and reconciliation reports.",
  },
  "/products/vedic-phala": {
    title: "Vedic Phala Astrology App & Panchang | Pi Consultants",
    description:
      "Vedic Phala is a Pi Consultants-owned multilingual Vedic astrology and pañcāṅga product, with a live website and Android and iPhone apps coming soon.",
  },
};

export const INDEXABLE_PATHS = Object.keys(SEO_BY_PATH);

export function normalizePath(path = "/") {
  const clean = path.split("?")[0].split("#")[0].replace(/\/+$/, "");
  return clean || "/";
}

export function seoForPath(path) {
  return SEO_BY_PATH[normalizePath(path)] || {
    title: "Page Not Found | Pi Consultants",
    description: defaultDescription,
    noindex: true,
  };
}

export function organizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Pi Consultants",
    url: SITE_URL,
    logo: `${SITE_URL}/icons/icon-512.png`,
    email: "hkundeti@piconsultants.us",
    telephone: "+1-818-800-2090",
    founder: [
      { "@type": "Person", name: "Hemanth Kundeti" },
      { "@type": "Person", name: "Ravi Teja Kundeti" },
    ],
    owns: {
      "@type": "SoftwareApplication",
      name: "Vedic Phala",
      url: "https://vedicphala.com",
      applicationCategory: "LifestyleApplication",
      operatingSystem: "Android, iOS",
    },
  };
}

export function productSchema(name, path, description, externalUrl) {
  return {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name,
    description,
    url: `${SITE_URL}${path}`,
    sameAs: externalUrl ? [externalUrl] : undefined,
    applicationCategory: name === "Vedic Phala" ? "LifestyleApplication" : "BusinessApplication",
    operatingSystem: name === "Vedic Phala" ? "Android, iOS, Web" : "Web",
    author: {
      "@type": "Organization",
      name: "Pi Consultants",
      url: SITE_URL,
    },
  };
}
